import { useState, useEffect } from 'react'
import { Select, Space } from 'antd'
import { StyledCard } from './styled'
import { Loading } from 'Components'
import { nameKey, typeRelation, quarterNode, getQuarters } from './helpers'
import Timer from './Timer'
import * as overviews from './overviews'
import moment from 'moment'

export default () => {

  const [loadingQuarters, setLoadingQuarters] = useState(false)
  const [quarters, setQuarters] = useState([])
  const [selectedQuarter, setSelectedQuarter] = useState()
  const [disabled, setDisabled] = useState(false)

  const [tabs, setTabs] = useState([])
  const [activeTab, setActiveTab] = useState(Object.keys(overviews).find((overview) => overview === 'NOKSignalen' ))

  const quarterAgnostic = ['NOKSignalen', 'ReeleAfsluitingen', 'VirtueleAfsluitingen']

  const organiseTabs = () => {
    const unorderdTabs = _.map(overviews, (overview, key) => {
      return {
        tab: overview.title,
        key: key
      }
    })
    return unorderdTabs.sort((a, b) => (b.key === 'NOKSignalen') - (a.key === 'NOKSignalen'));
  }

  useEffect(() => {
    (async () => {
      setTabs(organiseTabs())
      setLoadingQuarters(true)
      const qtrs = await getQuarters(typeRelation, quarterNode, nameKey)
      setQuarters(qtrs)
      setSelectedQuarter(getDefaultQuarter(qtrs))
      setLoadingQuarters(false)
    })()
  }, [])

  const getTabForItem = (Component) => {
    return <Component quarter={selectedQuarter} quarters={quarters}/>
  }

  const getDefaultQuarter = (qtrs) => {
    const today = moment();
    const lookForName = `${today.year()} Q${today.quarter()}`;

    const currentQtr = qtrs.find((qtr) => {
      if (qtr.get(nameKey) === lookForName) {
        return qtr
      }
    })

    if (currentQtr === undefined) {
      throw new Error(`Could not find quarter node for ${lookForName}`);
    }
    return currentQtr.id()
  }

  const qtrSelector = (
    <Select
      loading={loadingQuarters}
      placeholder="Selecteer een kwartaal"
      onChange={setSelectedQuarter}
      value={selectedQuarter}
      style={{ flex: '1 0 0' }}
      disabled={disabled}
    >
      {
        quarters.map((quarter) => {
          return (
            <Select.Option
              key={quarter.id()}
              value={quarter.id()}
            >
              { quarter.get(nameKey) }
            </Select.Option>
          )
        })
      }
    </Select>
  )

  const renderTitle = () => {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ margin: "5px 10px 5px 0px" }}>Overzicht</div>
        { disabled ? null : qtrSelector }
        <div style={{ flex: '3 0 0' }}>
          <Timer />
        </div>
      </div>
    )
  }

  const renderTables = () => {
    if (selectedQuarter) {
      return (
        <StyledCard
          title={renderTitle()}
          onTabChange={(key) => {
            quarterAgnostic.includes(key) ? setDisabled(true) : setDisabled(false)
            setActiveTab(key)
          }}
          tabList={tabs}
        >
          { getTabForItem(overviews[activeTab]) }
        </StyledCard>
      )
    } else {
      return (
        <Loading />
      )
    }
  }

  return (
    <Space direction="vertical">
      { renderTables() }
    </Space>
  )
}
